module.exports = __webpack_public_path__ + "1_0_60/img/mobile.ca3f80d0.png";